document.addEventListener(
  'click',
  function (event) {
    const button = event.target.closest('.size-swatch-btn');
    if (!button || button.disabled) return;

    // Empêche product-component d'intercepter le clic et de naviguer
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const variantId = button.getAttribute('data-variant-id');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => res.json())
      .then(() => {
        window.location.href = '/cart';
      })
      .catch((err) => console.error('Erreur ajout panier :', err));
  },
  true // <-- phase de capture, s'exécute avant product-component
);